/* eslint-disable react/forbid-prop-types,react/require-default-props */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CoursePageLink } from '../CoursePageLink/component';
import { CourseModuleLink } from '../CourseModuleLink/component';

export class CourseNavigationLinks extends PureComponent {
  static propTypes = {
    links: PropTypes.any.isRequired,
    currentModuleSet: PropTypes.string,
    makeSetCurrentModuleSetAction: PropTypes.func.isRequired,
    mobile: PropTypes.bool.isRequired,
    courseCode: PropTypes.string.isRequired,
    institutionPath: PropTypes.string,
  };

  render() {
    const {
      makeSetCurrentModuleSetAction,
      mobile,
      links,
      currentModuleSet,
      courseCode,
      institutionPath,
    } = this.props;
    return (
      <div className="section">
        <div className={classNames('heading', 'hideInSidebar')}>
          Course Navigation
        </div>
        <ul className="class-list">
          {links.map((link) => {
            switch (link.get('type')) {
              case 'navigation': {
                return (
                  <CoursePageLink
                    key={link.get('index')}
                    link={link}
                    currentModuleSet={currentModuleSet}
                    courseCode={courseCode}
                    institutionPath={institutionPath}
                  />
                );
              }
              case 'default-module-set':
              case 'module-set': {
                return (
                  <CourseModuleLink
                    key={link.get('index')}
                    link={link}
                    currentModuleSet={currentModuleSet}
                    makeSetCurrentModuleSetAction={
                      makeSetCurrentModuleSetAction
                    }
                    mobile={mobile}
                  />
                );
              }
              case 'separator': {
                return <li key={link.get('index')} className="separator" />;
              }
              default: {
                throw Error('Unknown link type');
              }
            }
          })}
        </ul>
      </div>
    );
  }
}
